export const getTransportCardNumber = (cardNumber: number | string): string => {
  const _cardNumber = String(cardNumber);

  if (_cardNumber.length !== 16) {
    return _cardNumber;
  }

  // 512133—222002040—0
  return _cardNumber.slice(6, -1);
};
